export type Lang = 'sv' | 'en';

type Dict = Record<string, { sv: string; en: string }>;

const dict: Dict = {
  'app.title': { sv: 'Waystone', en: 'Waystone' },
  'login.description': {
    sv: 'Ett samarbetsverktyg för kartdata. Importera en GPX- eller GeoJSON-fil eller redigera kartan direkt. Alla ändringar blir förslag som du och dina kollegor granskar tillsammans innan de blir en ny gemensam kartversion.',
    en: 'A collaborative workspace for map data. Import a GPX or GeoJSON file or edit the map directly. Every change becomes a proposal that you and your peers review together before it becomes a new shared map revision.',
  },
  'login.heading': { sv: 'Logga in med engångstoken', en: 'Sign in with a one-time token' },
  'login.email': { sv: 'E-post', en: 'Email' },
  'login.token': { sv: 'Engångstoken', en: 'One-time token' },
  'login.tokenSubmit': { sv: 'Logga in', en: 'Sign in' },
  'login.tokenHint': {
    sv: 'Token kan skickas via e-post eller av en administratör. Den kan bara användas en gång och gäller i {minutes} minuter. Om du redan var inloggad kan sessionen ha gått ut.',
    en: 'A token can be sent by email or by an administrator. It can be used once and expires after {minutes} minutes. If you were already signed in, your session may have expired.',
  },
  'login.requestHeading': { sv: 'Få en inloggningslänk', en: 'Get a sign-in link' },
  'login.requestHint': {
    sv: 'Ange din e-postadress. Om den tillhör en aktiv användare skickas en engångslänk.',
    en: 'Enter your email address. If it belongs to an active user, a one-time link will be sent.',
  },
  'login.requestSubmit': { sv: 'Skicka länk', en: 'Send link' },
  'login.linkRequested': {
    sv: 'Om adressen tillhör en aktiv användare har en inloggningslänk skickats.',
    en: 'If the address belongs to an active user, a sign-in link has been sent.',
  },
  'login.contactAdmin': {
    sv: 'Självbetjäning för inloggningslänkar är inte aktiverad. Kontakta en administratör.',
    en: 'Self-service sign-in links are not enabled. Contact an administrator.',
  },
  'login.tokenFailed': {
    sv: 'Token är ogiltig, redan använd eller har gått ut.',
    en: 'The token is invalid, already used or has expired.',
  },
  'login.devHeading': { sv: 'Utvecklingsinloggning', en: 'Development sign-in' },
  'login.devHint': {
    sv: 'Endast tillgänglig när DEV_LOGIN=1.',
    en: 'Only available when DEV_LOGIN=1.',
  },
  'login.devSubmit': { sv: 'Logga in (dev)', en: 'Sign in (dev)' },
  'login.failed': { sv: 'Inloggningen misslyckades.', en: 'Sign-in failed.' },
  'login.inviteAccepted': {
    sv: 'Inbjudan accepterad. Välkommen!',
    en: 'Invitation accepted. Welcome!',
  },
  'login.inviteFailed': {
    sv: 'Inbjudan är ogiltig eller har gått ut.',
    en: 'The invitation is invalid or has expired.',
  },
  'map.label': { sv: 'Karta', en: 'Map' },
  'map.view': { sv: 'Visning', en: 'View' },
  'map.actions': { sv: 'Åtgärder', en: 'Actions' },
  'layer.label': { sv: 'Lager', en: 'Layer' },
  'layer.osm': { sv: 'OpenStreetMap', en: 'OpenStreetMap' },
  'layer.topo': { sv: 'Topografisk', en: 'Topographic' },
  'layer.satellite': { sv: 'Satellit', en: 'Satellite' },
  'filter.type': { sv: 'Egenskapstyp', en: 'Attribute type' },
  'filter.kind': { sv: 'Objekttyp', en: 'Feature kind' },
  'filter.search': { sv: 'Sök', en: 'Search' },
  'filter.all': { sv: 'Alla', en: 'All' },
  'filter.label': { sv: 'Filter', en: 'Filter' },
  'filter.clear': { sv: 'Rensa filter', en: 'Clear filters' },
  'actions.import': { sv: 'Importera', en: 'Import' },
  'actions.exportGpx': { sv: 'Exportera GPX', en: 'Export GPX' },
  'actions.exportGeoJson': { sv: 'Exportera GeoJSON', en: 'Export GeoJSON' },
  'actions.logout': { sv: 'Logga ut', en: 'Sign out' },
  'actions.review': { sv: 'Granska förslag', en: 'Review proposal' },
  'review.title': { sv: 'Ändringar', en: 'Changes' },
  'review.back': { sv: '← Karta', en: '← Map' },
  'review.empty': { sv: 'Inga ändringar i detta förslag.', en: 'No changes in this proposal.' },
  'review.add': { sv: 'Tillägg', en: 'Additions' },
  'review.update': { sv: 'Uppdateringar', en: 'Updates' },
  'review.delete': { sv: 'Borttagningar', en: 'Removals' },
  'review.move': { sv: 'Möjlig flytt', en: 'Possible move' },
  'review.systematic': { sv: 'Systematisk förskjutning', en: 'Systematic shift' },
  'review.removalGroup': { sv: 'Stor borttagning', en: 'Large removal' },
  'review.candidate': { sv: 'Kandidat', en: 'Candidate' },
  'review.unnamed': { sv: '(saknar namn)', en: '(no name)' },
  'map.missingName': { sv: '⚠ Saknar namn', en: '⚠ Missing name' },
  'map.loading': { sv: 'Laddar…', en: 'Loading…' },
  'import.done': { sv: 'Förslag skapat', en: 'Proposal created' },
  'import.noChanges': {
    sv: 'Filen skulle inte ändra något. Inget förslag skapades.',
    en: 'The file would change nothing. No proposal was created.',
  },

  'actions.history': { sv: 'Historik', en: 'History' },
  'actions.notifications': { sv: 'Aviseringar', en: 'Notifications' },
  'actions.newMap': { sv: 'Ny karta', en: 'New map' },
  'actions.settings': { sv: 'Inställningar', en: 'Settings' },
  'actions.edit': { sv: 'Redigera', en: 'Edit' },
  'actions.dismiss': { sv: 'Stäng', en: 'Dismiss' },

  'tabs.map': { sv: 'Karta', en: 'Map' },
  'tabs.proposals': { sv: 'Förslag', en: 'Proposals' },
  'tabs.history': { sv: 'Historik', en: 'History' },
  'tabs.settings': { sv: 'Inställningar', en: 'Settings' },
  'tabs.team': { sv: 'Lag', en: 'Team' },
  'team.title': { sv: 'Lag', en: 'Team' },
  'team.back': { sv: '← Tillbaka', en: '← Back' },
  'team.hint': {
    sv: 'Hantera lagets namn, medlemmar och inbjudningar. Kartinställningar finns kvar under Inställningar.',
    en: 'Manage the team name, members and invitations. Map settings stay under Settings.',
  },
  'team.choose': { sv: 'Välj lag', en: 'Choose team' },
  'team.name': { sv: 'Lagnamn', en: 'Team name' },
  'team.rename': { sv: 'Byt namn', en: 'Rename' },
  'team.renamed': { sv: 'Lagets namn ändrades.', en: 'Team renamed.' },
  'team.renameFailed': { sv: 'Kunde inte byta namn på laget.', en: 'Could not rename the team.' },

  'proposals.empty': { sv: 'Inga förslag ännu.', en: 'No proposals yet.' },
  'proposals.open': { sv: 'Aktiva förslag', en: 'Active proposals' },
  'proposals.back': { sv: '← Förslag', en: '← Proposals' },
  'proposals.closed': { sv: 'Avslutade', en: 'Closed' },

  'map.none': { sv: 'Ingen karta vald.', en: 'No map selected.' },
  'map.none.hint': { sv: 'Välj en karta ovan eller skapa en ny.', en: 'Choose a map above or create one.' },
  'map.choose': { sv: 'Välj karta', en: 'Choose map' },

  'role.tenant_admin': { sv: 'Administratör', en: 'Administrator' },
  'role.contributor': { sv: 'Bidragsgivare', en: 'Contributor' },
  'role.viewer': { sv: 'Läsare', en: 'Viewer' },

  'kind.waypoint': { sv: 'Punkt', en: 'Waypoint' },
  'kind.track': { sv: 'Spår', en: 'Track' },
  'kind.route': { sv: 'Rutt', en: 'Route' },
  'kind.area': { sv: 'Yta', en: 'Area' },

  'edit.title': { sv: 'Redigera kartan', en: 'Edit the map' },
  'edit.tools': { sv: 'Verktyg', en: 'Tools' },
  'edit.object': { sv: 'Objekt', en: 'Feature' },
  'edit.changesTitle': { sv: 'Ändringar i förslaget', en: 'Changes in this proposal' },
  'edit.hint': {
    sv: 'Ändringar blir ett förslag som granskas som vanligt. Kartan förändras inte förrän det sammanfogas.',
    en: 'Your changes become a proposal, reviewed as usual. The map does not change until it is merged.',
  },
  'edit.addPoint': { sv: 'Lägg till punkt', en: 'Add point' },
  'edit.addLine': { sv: 'Ny linje', en: 'New line' },
  'edit.addArea': { sv: 'Ny yta', en: 'New area' },
  'edit.addVertex': { sv: 'Lägg till hörn', en: 'Add vertex' },
  'edit.deleteVertex': { sv: 'Ta bort hörn', en: 'Delete vertex' },
  'edit.finishLine': { sv: 'Klar', en: 'Done' },
  'edit.move': { sv: 'Flytta', en: 'Move' },
  'edit.delete': { sv: 'Ta bort', en: 'Delete' },
  'edit.clickToAdd': { sv: 'Klicka på kartan för att placera punkten.', en: 'Click the map to place the point.' },
  'edit.clickToMove': { sv: 'Klicka på kartan för att flytta punkten.', en: 'Click the map to move the point.' },
  'edit.clickToDraw': {
    sv: 'Klicka på kartan för att lägga hörn. Avsluta med Klar.',
    en: 'Click the map to add vertices. Finish with Done.',
  },
  'edit.clickToAddVertex': {
    sv: 'Klicka på kartan för att lägga till ett hörn i slutet av linjen.',
    en: 'Click the map to append a vertex to the line.',
  },
  'edit.clickToDrawArea': {
    sv: 'Klicka på kartan för att lägga hörn. Ringen sluts automatiskt; avsluta med Klar.',
    en: 'Click the map to add vertices. The ring closes automatically; finish with Done.',
  },
  'edit.select': { sv: 'Välj ett objekt på kartan, eller lägg till en punkt.', en: 'Select a feature on the map, or add a point.' },
  'edit.name': { sv: 'Namn', en: 'Name' },
  'edit.type': { sv: 'Typ', en: 'Type' },
  'type.freeTextHint': {
    sv: 'Välj en känd typ eller skriv ett eget värde.',
    en: 'Choose a known type or enter your own value.',
  },
  'type.known': { sv: 'Visa kända typer', en: 'Show known types' },
  'type.noMatches': { sv: 'Inga träffar.', en: 'No matches.' },
  'type.guideTitle': { sv: 'Kända typer', en: 'Known types' },
  'type.guideHint': {
    sv: 'Typerna är grupperade efter källa. Du kan fortfarande skriva vilket värde som helst.',
    en: 'Types are grouped by source. You can still enter any value.',
  },
  'edit.description': { sv: 'Beskrivning', en: 'Description' },
  'edit.untitled': { sv: '(namnlös)', en: '(untitled)' },
  'edit.deleted': { sv: 'Borttagen', en: 'Deleted' },
  'edit.save': { sv: 'Spara förslag', en: 'Save proposal' },
  'edit.cancel': { sv: 'Avbryt', en: 'Cancel' },
  'edit.continue': { sv: 'Fortsätt redigera', en: 'Continue editing' },
  'edit.changes': { sv: 'Ändringar', en: 'Changes' },
  'edit.noChanges': { sv: 'Inga ändringar att spara.', en: 'No changes to save.' },
  'edit.saved': { sv: 'Förslag skapat.', en: 'Proposal created.' },

  'settings.title': { sv: 'Kartinställningar', en: 'Map settings' },
  'settings.identity': { sv: 'Identitet', en: 'Identity' },
  'settings.identity.hint': {
    sv: 'Vilka fält avgör om två punkter är samma. Gäller nästa import.',
    en: 'Which fields decide whether two points are the same. Applies to the next import.',
  },
  'settings.identity.name': { sv: 'Namn', en: 'Name' },
  'settings.identity.nameType': { sv: 'Namn + typ', en: 'Name + type' },
  'settings.identity.nameTypeDesc': { sv: 'Namn + typ + beskrivning', en: 'Name + type + description' },
  'settings.identity.id': { sv: 'Endast id', en: 'Id only' },
  'settings.moveTolerance': { sv: 'Flyttolerans (m)', en: 'Move tolerance (m)' },
  'settings.geometryTolerance': { sv: 'Geometritolerans (m)', en: 'Geometry tolerance (m)' },
  'settings.requiredApprovals': { sv: 'Krävda godkännanden', en: 'Required approvals' },
  'settings.save': { sv: 'Spara inställningar', en: 'Save settings' },
  'settings.saved': { sv: 'Inställningar sparade.', en: 'Settings saved.' },
  'settings.savedRecomputed': {
    sv: 'Inställningarna sparades. {count} öppet förslag räknades om.',
    en: 'Settings saved. {count} open proposal(s) were recomputed.',
  },
  'settings.savedReapproval': {
    sv: 'Inställningarna sparades. {count} godkännande(n) behöver göras om.',
    en: 'Settings saved. {count} approval(s) need to be repeated.',
  },
  'settings.saveFailed': { sv: 'Kunde inte spara inställningarna.', en: 'Could not save the settings.' },
  'settings.reindex': { sv: 'Bygg om sökindex', en: 'Rebuild search index' },
  'settings.reindex.hint': {
    sv: 'Sökindexet uppdateras automatiskt när kartan ändras. Använd bara om sökning eller filtrering visar saknade eller gamla objekt.',
    en: 'The search index updates automatically when the map changes. Use only if search or filtering shows missing or stale features.',
  },
  'settings.reindexed': { sv: 'Sökindexet byggdes om.', en: 'Search index rebuilt.' },
  'settings.advanced': { sv: 'Avancerat', en: 'Advanced' },
  'settings.mapName': { sv: 'Kartans namn', en: 'Map name' },
  'settings.mapSection': { sv: 'Kartan', en: 'Map' },
  'settings.matching': { sv: 'Matchning och godkännande', en: 'Matching and approval' },
  'settings.matching.hint': {
    sv: 'Hur objekt identifieras, hur stora förflyttningar som accepteras och hur många godkännanden ett förslag kräver.',
    en: 'How features are identified, how much movement is accepted, and how many approvals a proposal requires.',
  },
  'settings.rename': { sv: 'Byt namn', en: 'Rename' },
  'settings.renamed': { sv: 'Kartans namn ändrades.', en: 'Map renamed.' },
  'settings.renameFailed': { sv: 'Kunde inte byta namn.', en: 'Could not rename the map.' },
  'settings.members': { sv: 'Medlemmar', en: 'Members' },
  'settings.members.hint': {
    sv: 'Bjud in via e-post. Ingen medlem skapas förrän inbjudan accepteras.',
    en: 'Invite by email. No member is created until the invitation is accepted.',
  },
  'settings.members.email': { sv: 'E-post', en: 'Email' },
  'settings.members.role': { sv: 'Roll', en: 'Role' },
  'settings.members.invite': { sv: 'Bjud in', en: 'Invite' },
  'settings.members.invitedEmail': {
    sv: 'Inbjudan köades för e-post.',
    en: 'Invitation email queued.',
  },
  'settings.members.invitedManual': {
    sv: 'Inbjudan skapad. E-post är inte konfigurerad – skicka länken manuellt.',
    en: 'Invitation created. Email is not configured — send the link manually.',
  },
  'settings.members.resentEmail': {
    sv: 'Inbjudan köades för e-post igen.',
    en: 'Invitation email queued again.',
  },
  'settings.members.resentManual': {
    sv: 'Ny inbjudan skapad. Skicka länken manuellt.',
    en: 'New invitation created. Send the link manually.',
  },
  'settings.members.inviteFailed': { sv: 'Kunde inte bjuda in.', en: 'Could not create the invitation.' },
  'settings.members.pending': { sv: 'Väntande inbjudningar', en: 'Pending invitations' },
  'settings.members.current': { sv: 'Nuvarande medlemmar', en: 'Current members' },
  'settings.members.none': { sv: 'Inga medlemmar.', en: 'No members.' },
  'settings.members.noPending': { sv: 'Inga väntande inbjudningar.', en: 'No pending invitations.' },
  'settings.members.link': { sv: 'Inbjudningslänk', en: 'Invitation link' },
  'settings.members.resend': { sv: 'Skicka igen', en: 'Resend' },
  'settings.members.revoke': { sv: 'Återkalla', en: 'Revoke' },
  'settings.members.remove': { sv: 'Ta bort', en: 'Remove' },
  'settings.members.removeConfirm': {
    sv: 'Ta bort {email} från teamet? Användaren och historiken finns kvar.',
    en: 'Remove {email} from the team? The user and their history remain.',
  },
  'settings.members.roleChanged': { sv: 'Rollen ändrades.', en: 'Role changed.' },
  'settings.members.removed': { sv: 'Medlemmen togs bort.', en: 'Member removed.' },
  'settings.members.changeFailed': { sv: 'Kunde inte ändra medlemmen.', en: 'Could not change the member.' },
  'settings.members.expires': { sv: 'Går ut', en: 'Expires' },
  'settings.members.lastLogin': { sv: 'Senaste inloggning', en: 'Last sign-in' },

  'review.changeActions': { sv: 'Ändringar', en: 'Changes' },
  'review.proposalActions': { sv: 'Förslaget', en: 'Proposal' },
  'change.current': { sv: 'Nuvarande', en: 'Current' },
  'change.proposed': { sv: 'Föreslagen', en: 'Proposed' },
  'change.from': { sv: 'Från', en: 'From' },
  'change.to': { sv: 'Till', en: 'To' },
  'change.details': { sv: 'Detaljer', en: 'Details' },
  'change.noFieldChanges': { sv: 'Inga fältändringar', en: 'No field changes' },
  'change.moved': { sv: 'Flyttad', en: 'Moved' },
  'change.coordinates': { sv: 'Koordinater', en: 'Coordinates' },
  'change.vertices': { sv: 'punkter', en: 'vertices' },
  'change.noMatch': { sv: 'Ingen befintlig träff på', en: 'No existing match on' },
  'change.matchedOn': { sv: 'Matchad på', en: 'Matched on' },
  'change.absent': { sv: 'Saknas i filen', en: 'Absent from the file' },
  'change.noStrategy': { sv: 'inget kriterium', en: 'no criterion' },

  'map.new.file': { sv: 'Startfil (valfritt)', en: 'Initial file (optional)' },
  'map.new.fileHint': {
    sv: 'Läses in direkt som kartans innehåll (ingen granskning).',
    en: 'Loaded directly as the map content (no review).',
  },
  'map.new.createdWithData': { sv: 'Karta skapad och innehållet inläst.', en: 'Map created and its content loaded.' },
  'map.new.uploadFailed': {
    sv: 'Kartan skapades, men filen kunde inte läsas in.',
    en: 'The map was created, but the file could not be loaded.',
  },
  'map.delete.title': { sv: 'Ta bort karta', en: 'Delete map' },
  'map.delete.hint': {
    sv: 'Kartan och hela dess historik tas bort permanent. Det går inte att ångra.',
    en: 'The map and its entire history are permanently removed. This cannot be undone.',
  },
  'map.delete.button': { sv: 'Ta bort kartan', en: 'Delete map' },
  'map.delete.confirm': { sv: 'Ja, ta bort', en: 'Yes, delete' },
  'map.delete.done': { sv: 'Kartan togs bort.', en: 'Map deleted.' },
  'map.delete.failed': { sv: 'Kunde inte ta bort kartan.', en: 'Could not delete the map.' },

  'map.new.title': { sv: 'Ny karta', en: 'New map' },
  'map.new.team': { sv: 'Lag', en: 'Team' },
  'map.new.name': { sv: 'Namn', en: 'Name' },
  'map.new.placeholder': { sv: 't.ex. Norra såten', en: 'e.g. North ridge' },
  'map.new.create': { sv: 'Skapa', en: 'Create' },
  'map.new.cancel': { sv: 'Avbryt', en: 'Cancel' },
  'map.new.created': { sv: 'Karta skapad', en: 'Map created' },
  'map.new.failed': { sv: 'Kunde inte skapa kartan.', en: 'Could not create the map.' },

  'status.open': { sv: 'Öppen', en: 'Open' },
  'status.approved': { sv: 'Godkänd', en: 'Approved' },
  'status.rejected': { sv: 'Avslagen', en: 'Rejected' },
  'status.done': { sv: 'Slutförd', en: 'Done' },
  'status.aborted': { sv: 'Avbruten', en: 'Aborted' },

  'review.quorum': { sv: 'Godkännanden', en: 'Approvals' },
  'review.acceptAll': { sv: 'Acceptera alla', en: 'Accept all' },
  'review.rejectAll': { sv: 'Avvisa alla', en: 'Reject all' },
  'review.approve': { sv: 'Godkänn', en: 'Approve' },
  'review.rejectProposal': { sv: 'Avslå', en: 'Reject' },
  'review.merge': { sv: 'Sammanfoga', en: 'Merge' },
  'review.withdraw': { sv: 'Avbryt', en: 'Cancel' },
  'review.accept': { sv: 'Acceptera', en: 'Accept' },
  'review.rejectItem': { sv: 'Avvisa', en: 'Reject' },
  'review.acceptMove': { sv: 'Acceptera flytt', en: 'Accept move' },
  'review.rejectMove': { sv: 'Avvisa flytt', en: 'Reject move' },
  'review.reset': { sv: 'Återställ', en: 'Reset' },
  'review.pendingBlocksMerge': {
    sv: 'Alla ändringar måste accepteras eller avvisas innan sammanfogning.',
    en: 'Every change must be accepted or rejected before merging.',
  },
  'review.ownVoteNoCount': {
    sv: 'Din egen röst räknas inte; du behöver godkännande från någon annan.',
    en: 'Your own vote does not count; you need approval from someone else.',
  },
  'review.mergedAs': { sv: 'Publicerad som revision', en: 'Published as revision' },
  'review.closed': {
    sv: 'Förslaget är avslutat och kan inte ändras.',
    en: 'This proposal is closed and cannot be changed.',
  },
  'review.comments': { sv: 'Kommentarer', en: 'Comments' },
  'review.comment.placeholder': { sv: 'Skriv en kommentar…', en: 'Write a comment…' },
  'review.comment.add': { sv: 'Skicka', en: 'Send' },
  'review.comment.none': { sv: 'Inga kommentarer', en: 'No comments' },
  'review.comment.orphaned': {
    sv: 'till en ändring som inte längre finns',
    en: 'on a change that no longer exists',
  },
  'review.noPermission': {
    sv: 'Du har inte behörighet att granska ändringar.',
    en: 'You do not have permission to review changes.',
  },

  'history.title': { sv: 'Historik', en: 'History' },
  'history.revert': { sv: 'Återställ', en: 'Restore' },
  'history.empty': { sv: 'Ingen historik ännu.', en: 'No history yet.' },
  'history.reverted': { sv: 'Återställd till tidigare revision', en: 'Restored an earlier revision' },
  'history.source.import': { sv: 'import', en: 'import' },
  'history.source.revert': { sv: 'återställning', en: 'restore' },
  'history.source.merge': { sv: 'sammanfogning', en: 'merge' },
  'history.verify': { sv: 'Verifiera', en: 'Verify' },
  'history.verified': { sv: 'Kedjan är intakt', en: 'The chain is intact' },
  'history.verifyBroken': { sv: 'Kedjan är bruten vid revision', en: 'The chain is broken at revision' },
  'history.applied': { sv: 'ändringar tillämpade', en: 'changes applied' },
  'history.undecided': { sv: 'obeslutade', en: 'undecided' },
  'history.rejectedItems': { sv: 'avvisade', en: 'rejected' },
  'history.features': { sv: 'objekt', en: 'features' },

  'actions.export': { sv: 'Exportera', en: 'Export' },
  'export.gpx10': { sv: 'GPX 1.0 (äldre)', en: 'GPX 1.0 (legacy)' },
  'export.geojson': { sv: 'GeoJSON', en: 'GeoJSON' },
  'export.zip': { sv: 'GPX + GeoJSON (ZIP)', en: 'GPX + GeoJSON (ZIP)' },
  'export.more': { sv: 'Fler format', en: 'More formats' },

  'feature.history.title': { sv: 'Objektets historik', en: 'Feature history' },
  'feature.added': { sv: 'tillagd', en: 'added' },
  'feature.updated': { sv: 'ändrad', en: 'updated' },
  'feature.removed': { sv: 'borttagen', en: 'removed' },
  'feature.empty': { sv: 'Ingen historik för objektet.', en: 'No history for this feature.' },

  'notifications.title': { sv: 'Aviseringar', en: 'Notifications' },
  'notifications.markRead': { sv: 'Markera alla som lästa', en: 'Mark all read' },
  'notifications.markReadOne': { sv: 'Markera som läst', en: 'Mark as read' },
  'notifications.empty': { sv: 'Inga aviseringar.', en: 'No notifications.' },

  // Structured warnings. Core emits a code + params; the UI localises them.
  'warning.unnamed-features': {
    sv: '{count} objekt saknar namn.',
    en: '{count} feature(s) have no name.',
  },
  'warning.skipped-waypoint': {
    sv: '{count} punkt(er) hoppades över (saknar giltig lat/lon).',
    en: '{count} waypoint(s) skipped (missing or invalid lat/lon).',
  },
  'warning.skipped-track': {
    sv: '{count} spår hoppades över (inga punkter).',
    en: '{count} track(s) skipped (no points).',
  },
  'warning.skipped-route': {
    sv: '{count} rutt(er) hoppades över (inga punkter).',
    en: '{count} route(s) skipped (no points).',
  },
  'warning.skipped-non-feature': {
    sv: '{count} poster hoppades över (inte ett objekt).',
    en: '{count} entr(y/ies) skipped (not a Feature).',
  },
  'warning.unsupported-geometry': {
    sv: '{count} objekt hoppades över (geometritypen stöds inte).',
    en: '{count} feature(s) skipped (unsupported geometry).',
  },
  'warning.systematic-offset': {
    sv: '{count} objekt verkar förskjutna ~{distanceM} m i samma riktning — presenterat som en systematisk förskjutning.',
    en: '{count} features appear shifted ~{distanceM} m in a similar direction — presented as one systematic offset.',
  },
  'warning.no-lines': {
    sv: 'Filen innehåller inga spår eller rutter; {count} skulle tas bort om hela filen accepteras.',
    en: 'This file contains no tracks or routes; {count} would be removed if the whole file is accepted.',
  },
  'warning.bulk-removal': {
    sv: '{count} objekt ({share} %) saknas i filen och skulle tas bort om hela filen accepteras.',
    en: '{count} features ({share}%) are absent from the file and would be removed if the whole file is accepted.',
  },
  'warning.no-changes': {
    sv: 'Filen skulle inte ändra något. Inget förslag skapades.',
    en: 'The file would change nothing. No proposal was created.',
  },

  // Row chips and their longer explanation inside the expanded details.
  'chip.duplicate-in-file': { sv: 'Dubblett', en: 'Duplicate' },
  'chip.two-candidates': { sv: 'Oklar matchning', en: 'Ambiguous match' },
  'chip.unnamed-track': { sv: 'Saknar namn', en: 'Missing name' },
  'chip.missing-name': { sv: 'Saknar namn', en: 'Missing name' },
  'notice.move': {
    sv: 'Objektet har flyttats. Acceptera både borttagningen och tillägget för att flytta det; annars raderas/skapas det.',
    en: 'The feature moved. Accept both the removal and the addition to move it; otherwise it is deleted/created.',
  },
  'notice.systematic': {
    sv: 'Objektet ingår i en grupp som verkar vara systematiskt förskjuten. Kontrollera om det är en verklig flytt.',
    en: 'This feature is part of a group that appears systematically shifted. Check whether it is a real move.',
  },
  'notice.removalGroup': {
    sv: 'Objektet ingår i en stor borttagning. Bekräfta att filen är komplett innan du accepterar.',
    en: 'This feature is part of a large removal. Confirm the file is complete before accepting.',
  },
  'notice.duplicate-in-file': {
    sv: 'Samma namn och typ förekommer flera gånger i filen.',
    en: 'The same name and type occur more than once in the file.',
  },
  'notice.two-candidates': {
    sv: 'Flera befintliga objekt har samma namn och typ, så raden kan inte matchas säkert. Kontrollera om det är en dubblett eller ett nytt objekt.',
    en: 'Several existing features share the same name and type, so this row cannot be matched safely. Check whether it is a duplicate or a new feature.',
  },
  'notice.two-candidates.map': {
    sv: 'Kandidaterna är markerade på kartan.',
    en: 'The candidates are highlighted on the map.',
  },
  'notice.unnamed-track': {
    sv: 'Objektet saknar namn och kan inte matchas säkert.',
    en: 'The feature has no name and cannot be matched safely.',
  },

  'admin.title': { sv: 'Administration', en: 'Administration' },
  'admin.hint': {
    sv: 'Hantera team, användare och den globala typkatalogen. Plattformsadministratören har ingen åtkomst till teamens kartor.',
    en: 'Manage teams, users and the global type catalog. The platform admin has no access to tenant maps.',
  },
  'admin.back': { sv: '← Till kartan', en: '← Back to map' },
  'admin.newTenant': { sv: 'Nytt team', en: 'New team' },
  'admin.tenantName': { sv: 'Teamnamn', en: 'Team name' },
  'admin.firstAdminEmail': { sv: 'Första administratörens e-post', en: 'First admin email' },
  'admin.createTenant': { sv: 'Skapa team', en: 'Create team' },
  'admin.tenantCreated': { sv: 'Teamet skapades. Skicka inbjudningslänken manuellt.', en: 'Team created. Send the invitation link manually.' },
  'admin.tenantCreatedEmail': {
    sv: 'Teamet skapades och inbjudan köades för e-post.',
    en: 'Team created and the invitation email was queued.',
  },
  'admin.tenants': { sv: 'Team', en: 'Teams' },
  'admin.showArchived': { sv: 'Visa arkiverade', en: 'Show archived' },
  'admin.noTenants': { sv: 'Inga team.', en: 'No teams.' },
  'admin.tenantMeta': {
    sv: '{members} medlemmar · {maps} kartor · admin: {admin}',
    en: '{members} members · {maps} maps · admin: {admin}',
  },
  'admin.noAdmin': { sv: 'ingen', en: 'none' },
  'admin.suspend': { sv: 'Stäng av', en: 'Suspend' },
  'admin.archive': { sv: 'Arkivera', en: 'Archive' },
  'admin.restore': { sv: 'Återställ', en: 'Restore' },
  'admin.changeAdmin': { sv: 'Byt admin', en: 'Change admin' },
  'admin.changeAdminEmail': { sv: 'Ny admin-e-post', en: 'New admin email' },
  'admin.adminChanged': { sv: 'Administratören byttes. Skicka inloggningslänken manuellt.', en: 'Administrator changed. Send the login link manually.' },
  'admin.adminChangedEmail': {
    sv: 'Administratören byttes och inloggningslänken köades för e-post.',
    en: 'Administrator changed and the login link email was queued.',
  },
  'admin.link': { sv: 'Länk att skicka', en: 'Link to send' },
  'admin.tenantUpdated': { sv: 'Teamet uppdaterades.', en: 'Team updated.' },
  'admin.renameTenant': { sv: 'Byt namn', en: 'Rename' },
  'admin.tenantRenamed': { sv: 'Teamets namn ändrades.', en: 'Tenant renamed.' },
  'admin.renameFailed': { sv: 'Kunde inte byta namn på teamet.', en: 'Could not rename the tenant.' },
  'admin.typeCatalog': { sv: 'Typkatalog', en: 'Type catalog' },
  'admin.typeCatalogHint': {
    sv: 'Globala typer som visas som förslag i karteditorn. Kartdata påverkas inte när listan ändras.',
    en: 'Global types offered as suggestions in the map editor. Changing the catalog does not change map data.',
  },
  'admin.typeSource': { sv: 'Källa', en: 'Source' },
  'admin.typeValue': { sv: 'Exakt värde', en: 'Exact value' },
  'admin.typeLabelEn': { sv: 'Engelsk etikett', en: 'English label' },
  'admin.typeLabelSv': { sv: 'Svensk etikett', en: 'Swedish label' },
  'admin.typeDescriptionEn': { sv: 'Engelsk beskrivning', en: 'English description' },
  'admin.typeDescriptionSv': { sv: 'Svensk beskrivning', en: 'Swedish description' },
  'admin.typeSort': { sv: 'Sortering', en: 'Sort' },
  'admin.typeAdd': { sv: 'Lägg till typ', en: 'Add type' },
  'admin.typeSave': { sv: 'Spara typ', en: 'Save type' },
  'admin.typeCancel': { sv: 'Avbryt', en: 'Cancel' },
  'admin.typeEdit': { sv: 'Redigera', en: 'Edit' },
  'admin.typeDelete': { sv: 'Ta bort', en: 'Delete' },
  'admin.typeDeleteConfirm': {
    sv: 'Ta bort {value} ({source}) från typkatalogen? Kartdata påverkas inte.',
    en: 'Remove {value} ({source}) from the type catalog? Map data is unaffected.',
  },
  'admin.typeCreated': { sv: 'Typen lades till.', en: 'Type added.' },
  'admin.typeUpdated': { sv: 'Typen uppdaterades.', en: 'Type updated.' },
  'admin.typeDeleted': { sv: 'Typen togs bort.', en: 'Type removed.' },
  'admin.typeSaveFailed': { sv: 'Kunde inte spara typen.', en: 'Could not save the type.' },
  'admin.typeEmpty': { sv: 'Inga typer i katalogen.', en: 'No types in the catalog.' },
  'admin.users': { sv: 'Användare', en: 'Users' },
  'admin.showInactive': { sv: 'Visa inaktiva', en: 'Show inactive' },
  'admin.noUsers': { sv: 'Inga användare.', en: 'No users.' },
  'admin.platformAdmin': { sv: 'Plattformsadmin', en: 'Platform admin' },
  'admin.inactive': { sv: 'Inaktiv', en: 'Inactive' },
  'admin.lastLogin': { sv: 'Senaste inloggning', en: 'Last sign-in' },
  'admin.noMemberships': { sv: 'Inga medlemskap', en: 'No memberships' },
  'admin.deactivate': { sv: 'Inaktivera', en: 'Deactivate' },
  'admin.reactivate': { sv: 'Aktivera', en: 'Reactivate' },
  'admin.deleteUser': { sv: 'Radera tom användare', en: 'Delete empty user' },
  'admin.deleteUserConfirm': {
    sv: 'Radera {email}? Endast användare utan medlemskap och historik kan raderas.',
    en: 'Delete {email}? Only users with no memberships or history can be deleted.',
  },
  'admin.userUpdated': { sv: 'Användaren uppdaterades.', en: 'User updated.' },
  'admin.userDeleted': { sv: 'Användaren raderades.', en: 'User deleted.' },
  'admin.status.active': { sv: 'Aktiv', en: 'Active' },
  'admin.status.suspended': { sv: 'Avstängd', en: 'Suspended' },
  'admin.status.archived': { sv: 'Arkiverad', en: 'Archived' },
};

export type Translate = (key: string, params?: Record<string, string | number>) => string;

export function makeT(lang: Lang): Translate {
  return (key, params) => {
    let text = dict[key]?.[lang] ?? key;
    if (params) {
      for (const [name, value] of Object.entries(params)) {
        text = text.split(`{${name}}`).join(String(value));
      }
    }
    return text;
  };
}
